module.exports = __webpack_public_path__ + "img/p-single-g1.141a41e8.jpg";